import React from 'react';
const columns = [
  {
    title: "Employee ID",
    dataIndex: "uid",
    width: 130, 
  },
  {
    title: "Employee Name",
    dataIndex: "name",
    render: (text, record) => `${record.name}`,
    width: 150,
  },
  {
    title: "Total Experience",
    dataIndex: "overallExp",
    width: 120,
    
  },
  {
    title: "Primary Skill",
    dataIndex: "primarySkill",
    width: 130,
  },
  {
    title: "Primary Skill Experience",
    dataIndex: "expInPrimarySkill",
    width: 120,
  },
  {
    title: "Status",
    dataIndex: "status",
    width: 90,
  },
  {
    title: "Location",
    dataIndex: "location",
    width: 100,
  },
  {
    title: "Certifications",
    dataIndex: "certifications",
    render: (certifications) => {
      if (!certifications || certifications.length === 0) {
        return "";
      }  
      return certifications.map((cert, index) => (
        <React.Fragment key={cert}>
          {cert}
          {index < certifications.length - 1 && <>,<br/></>}
        </React.Fragment>
      ));
    },
    width: 300,
  }
];

export default columns;
